jQuery(document).ready(function($) {
  new Swiper('.rooms .content_slider.swiper, .rooms .image_slider.swiper', {
    loop: true,
    slidesPerView: 1,
    speed: 500,
    spaceBetween: 2,
    allowTouchMove: false,
    navigation: {
      nextEl: '.rooms .slider-next',
      prevEl: '.rooms .slider-prev',
    },
  })
})